export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-8 mb-16">
          <div>
            <p className="text-sm font-bold text-gray-400 tracking-widest mb-3">OUR EXPERTISE</p>
            <h2 className="text-5xl font-bold text-gray-900 italic" style={{ fontFamily: 'Georgia, serif' }}>
              Comprehensive Electrical Solutions
            </h2>
          </div>
          <p className="text-gray-600 max-w-xl leading-relaxed">
            We provide end-to-end electrical services for residential, commercial, and industrial requirements with a focus on quality, safety, and reliability.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
            <div className="h-64">
              <img
                src="https://public.readdy.ai/ai/img_res/724b56ea8137424d1bd1d722cb5a2a9d.jpg"
                alt="Cable Laying Work"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 space-y-4">
              <div className="inline-block px-3 py-1 bg-lime-500 text-gray-900 text-xs font-bold rounded-full">
                INFRASTRUCTURE
              </div>
              <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                Cable Laying
              </h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Underground & Overhead Cable Installation</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Cable Jointing & Termination</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Load Testing & Commissioning</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-slate-800 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
            <div className="p-6 flex items-center justify-center h-64">
              <div className="w-32 h-32 flex items-center justify-center">
                <i className="ri-dashboard-line text-9xl text-lime-400"></i>
              </div>
            </div>
            <div className="p-6 space-y-4">
              <div className="inline-block px-3 py-1 bg-lime-500 text-gray-900 text-xs font-bold rounded-full">
                INSTALLATION
              </div>
              <h3 className="text-2xl font-bold text-white leading-tight">
                Meter & Panel Installation
              </h3>
              <ul className="space-y-2 text-sm text-gray-300">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-lime-400 mt-1"></i>
                  <span>Digital & Analog Meter Installation</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-lime-400 mt-1"></i>
                  <span>Meter Replacement & Upgrades</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-lime-400 mt-1"></i>
                  <span>Distribution Panel Setup</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-lime-400 mt-1"></i>
                  <span>Panel Maintenance & Safety Checks</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
            <div className="h-64">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20residential%20electrical%20wiring%20installation%20showing%20modern%20home%20electrical%20system%20with%20organized%20cable%20management%20switches%20and%20outlets%20being%20installed%20by%20skilled%20electrician%20clean%20interior%20construction%20photography%20featuring%20proper%20wiring%20techniques%20safety%20standards%20and%20attention%20to%20detail%20simple%20residential%20background%20emphasizing%20quality%20workmanship&width=400&height=300&seq=service-residential-001&orientation=landscape"
                alt="Household Wiring"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-6 space-y-4">
              <div className="inline-block px-3 py-1 bg-lime-500 text-gray-900 text-xs font-bold rounded-full">
                RESIDENTIAL
              </div>
              <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                Complete Home Electrical Solutions
              </h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>New Construction Wiring</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Renovation & Rewiring Projects</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Fault Detection & Repairs</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-sky-500 mt-1"></i>
                  <span>Electrical Safety Inspections</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-slate-50 p-6 rounded-2xl hover:bg-slate-100 transition-colors">
            <div className="w-10 h-10 bg-sky-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shopping-cart-line text-xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Electrical Trading & Supply</h4>
            <p className="text-sm text-gray-600">Quality electrical materials and equipment supply</p>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl hover:bg-slate-100 transition-colors">
            <div className="w-10 h-10 bg-sky-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-building-line text-xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Complete Electrical Contracting</h4>
            <p className="text-sm text-gray-600">End-to-end project management and execution</p>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl hover:bg-slate-100 transition-colors">
            <div className="w-10 h-10 bg-sky-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-tools-line text-xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Maintenance Services</h4>
            <p className="text-sm text-gray-600">Regular maintenance and emergency repairs</p>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl hover:bg-slate-100 transition-colors">
            <div className="w-10 h-10 bg-sky-500 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-flashlight-line text-xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Load Testing & Safety</h4>
            <p className="text-sm text-gray-600">Comprehensive testing and safety compliance</p>
          </div>
        </div>
      </div>
    </section>
  );
}
